import { Input } from 'antd';

const HVInput = ({ helpers, meta, ...props }) => {
    return <Input {...props} />;
};

export default HVInput;
